/**
* User management & login
*/
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
        .state('member.orders', {
            url: '/' + urls.member.orders.fr, // TODO : when multilang, change this to something dynamic
            abstract: true,
            views: {
                aside: {
                    templateUrl: 'src/views/member/member_aside.html'
                },
                content: {
                    controller: ['$scope', '$rootScope', '$filter', '$cookies', '$window', 'drupal', '$state', function ($scope, $rootScope, $filter, $cookies, $window, drupal, $state) {
                        if ($cookies.get('mpi_session') && $window.localStorage.getItem('order') && $cookies.get('bill_input')){
                            $scope.loadingExit = true;
                            var mpi_session = $cookies.get('mpi_session');
                            var bill_input = $cookies.get('bill_input');
                            $scope.order = JSON.parse($window.localStorage.getItem('order'));

                            drupal.soldPaybox($scope.order, bill_input, 'order', mpi_session).then(function(data) {
                            $cookies.remove('mpi_session');
                            $window.localStorage.removeItem('order');

                                if ($scope.order.caution > 0 && $scope.order.caution < $rootScope.config.site.caution) {
                                return drupal.capturePaybox($scope.order, mpi_session).then(function() {
                                    return data;
                                });
                            }
                            return data;
                            }).then(function(data) {

                                if (data.codereponse === '00000') {
                                // Success.
                                    $state.reload();
                                    swal({
                                        title: 'Paiement effectué',
                                        text: 'Votre paiement a été effectué avec succès.\nNuméro d\'autorisation : ' + data.autorisation,
                                        icon: 'success'
                                    }).then(function() {
                                        // $scope.fillOrderList();
                                        $scope.loadingExit = false;
                                    });
                                }
                                else {
                                    // Failure.
                                    $scope.loadingExit = false;
                                    swal({
                                        title: 'Une erreur est survenue',
                                        text: 'Votre paiement a été refusé pour la raison suivante :\n' + data.commentaire,
                                        icon: 'error'
                                    });
                                }
                            }).catch(function() {
                                $scope.loadingExit = false;
                                swal({
                                    title: 'Une erreur est survenue',
                                    text: 'Une erreur interne est survenue.',
                                    icon: 'error'
                                });
                            }).finally(function() {
                            });
                        }

                        // remove warning message
                        if ($scope.teaserPanel.css === 'info') {
                            angular.merge($scope.teaserPanel, { css: null, body: null });
                        }

                        if ($scope.breadcrumb.length > 2) {
                            $scope.breadcrumb.pop();
                        }
                        var sMyOrders = $filter('translate')('account.myOrders');
                        $scope.breadcrumb.push({ label: sMyOrders, state: 'member.orders.list' });
                        $rootScope.title = $filter('translate')('account.title') + ' - ' + sMyOrders.toLowerCase();
                        $rootScope.titlePanel = sMyOrders;
                    }],
                    template: '<div ui-view="subcontent"></div>'
                }
            }
        })
        .state('member.orders.list', {
            url: '/' + urls.member.orders.list.fr, // TODO : when multilang, change this to something dynamic
            views: {
                aside: {
                    templateUrl: 'src/views/member/member_aside.html'
                },
                subcontent: {
                    controller: ['$scope', '$rootScope', 'drupal', 'profile', 'tools', '$q', 'moment', function ($scope, $rootScope, drupal, profile, tools, $q, moment) {
                        $scope.loading = true;

                        // documents model
                        $scope.certificate = {
                            label: 'account.documentMedicalCertificat',
                            labelAdd: 'account.documentAdd',
                            type: 'Certificat médical',
                            icon: 'medical-certificate',
                            new: {}
                        };
                        $scope.record = {
                            label: 'account.documentRecord',
                            labelAdd: 'account.documentAdd',
                            type: 'Fiche de liaison',
                            icon: 'document',
                            new: {}
                        };
                        $scope.rules = {
                            label: 'account.documentRules',
                            labelAdd: 'account.documentAdd',
                            type: 'Règle de fonctionnement',
                            icon: 'document',
                            new: {}
                        };
                        $scope.permissionauth = {
                            label: 'account.documentPermissionAuth',
                            labelAdd: 'account.documentAdd',
                            type: 'Autorisation de sortie du territoire',
                            icon: 'document',
                            new: {}
                        };

                        $scope.participants = {};

                        function loadFiles(userId) {
                            return drupal.getAccountFiles(userId).then(function (result) {
                                $scope.participants[userId].forEach(function (document) {
                                    if (result[document.type]) {
                                        document.current = { name: document.label, icon: document.icon, uri: result[document.type].uri, created: result[document.type].created };
                                    }
                                });
                            });
                        }

                        // input file callback
                        $scope.upload = function (document, userId) {
                            // prevent multiple call
                            drupal.uploadAccountFile(userId, {
                                type: document.type,
                                filename: document.new[0].filename,
                                filemime: document.new[0].filemime,
                                data: document.new[0].data
                            }).then(function () {
                                // reload only specific user documents
                                loadFiles(userId);
                            });
                        };

                        // retrieve orders
                        drupal.getAccountOrders(profile.info.field_sfid).then(function (orders) {
                            orders.forEach(function (order) {
                                order.lines.forEach(function (line) {
                                    (line.participants || []).forEach(function (participant) {
                                        if(!$scope.participants[participant.sfid]) {
                                            $scope.participants[participant.sfid] = [angular.copy($scope.certificate)];
                                            if (tools.isMinor(participant.birthdate)) {
                                                $scope.participants[participant.sfid].push(angular.copy($scope.record), angular.copy($scope.rules), angular.copy($scope.permissionauth));
                                            }
                                        }
                                        participant.documents = $scope.participants[participant.sfid];
                                    });
                                });
                            });
                            $scope.orders = orders.sort(function (a, b) {
                                return moment(a.date).isBefore(b.date);
                            });

                            // retrieve current documents (queue api call)
                            Object.keys($scope.participants).reduce(function (previous, next) {
                                return previous.then(function () {
                                    return loadFiles(next);
                                });
                            }, $q.resolve());
                        }).finally(function () {
                            $scope.loading = false;
                        });
                    }],
                    templateUrl: 'src/views/member/member_orders.html'
                }
            }
        });
}]);
